import { Navigate, Outlet, useLocation } from 'react-router-dom'

export const RequireAdminAuth = ({ children }) => {
  const location = useLocation()

  const token = localStorage.getItem('token') || null

  if (!token) {
    return <Navigate to='/admin/login' state={{ from: location.pathname }} replace />
  }

  return children
}

export const RequireRole = ({ roles }) => {
  const location = useLocation()

  const user = JSON.parse(localStorage.getItem('user')) || null

  const userRole = user?.role || null

  const hasRequiredRole = roles.includes(userRole)

  if (!hasRequiredRole) {
    return <Navigate to='/unauthorized' state={{ from: location.pathname }} replace />
  }

  return <Outlet />
}
